<template>
  <layout>
    <section id="explain" class="explain">
      <b-container>
        <div class="intro">
          <h2>{{ $t('pages.cgv.title') }}</h2>
        </div>
        <div v-html="$t('pages.cgv.text')" />
      </b-container>
    </section>
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';

  export default {
    name: 'Cgv',
    components: {
      Layout,
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/views/Default/Cgv.vue